const HQLinks = [
  {
    text: "New Branch",
    access: false,
    icon: "fas fa-igloo",
    to: "/newbranch",
  },
  {
    text: "Charge Expense",
    access: false,
    icon: "fas fa-charging-station",
    to: "/chargeexpense",
  },

  // Saving
  // {
  //   hasChild: true,
  //   icon: "fas fa-university",
  //   text: "Client Saving",
  //   child: [
  //     {
  //       access: false,
  //       text: "New client",
  //       icon: "fas fa-user-plus",
  //       to: "/newCustomer"
  //     },
  //     {
  //       access: false,
  //       text: "All Clients",
  //       icon: "fas fa-users",
  //       to: "/customers"
  //     },
  //     {
  //       access: false,
  //       text: "Client Report",
  //       icon: "fas fa-receipt",
  //       to: "/transactions"
  //     },
  //     {
  //       access: false,
  //       text: "Debts",
  //       icon: "fas fa-clipboard-list",
  //       to: "/debts"
  //     },
  //     {
  //       access: false,
  //       text: "Daily Book",
  //       icon: "fas fa-file-medical-alt",
  //       to: "/BankReports"
  //     },
  //     {
  //       access: false,
  //       text: "Account Report",
  //       icon: "fas fa-network-wired",
  //       to: "/clientCashes"
  //     }
  //   ]
  // },
  // Exchange
  {
    hasChild: true,
    icon: "fas fa-globe",
    text: "Exchange",
    child: [
      {
        access: false,
        text: "Exchange",
        icon: "fas fa-chart-line",
        to: "/exchangeDash",
      },
      {
        access: false,
        text: "Exchange Report",
        icon: "fas fa-file-invoice-dollar",
        to: "/exchangeReport",
      },
      {
        access: false,
        text: "USD Report",
        icon: "fas fa-search-dollar",
        to: "/USDReport",
      },
    ],
  },
];
const BranchLink = [
  // Saving
  {
    hasChild: true,
    icon: "fas fa-university",
    text: "Qaasas",
    child: [
      {
        access: false,
        text: "All Qaas",
        icon: "fas fa-users",
        to: "/qaases",
      },
      {
        access: false,
        text: "Qaas Report",
        icon: "fas fa-file-medical-alt",
        to: "/QaasReport",
      },
    ],
  },
  // Inventory
  {
    hasChild: true,
    icon: "fas fa-sitemap",
    text: "Stocks",
    child: [
      // {
      //   access: false,
      //   text: "On The Way",
      //   icon: "fas fa-truck-moving",
      //   to: "/theway"
      // },
      {
        access: false,
        text: "New Stock",
        icon: "fas fa-dolly",
        to: "/newStock",
      },
      {
        access: false,
        text: "Transfer",
        icon: "fas fa-exchange-alt",
        to: "/transfer",
      },

      {
        access: false,
        text: "Supplier",
        icon: "fas fa-user-tie",
        to: "/supplier",
      },
      {
        access: false,
        text: "Other Cost",
        icon: "fas fa-cart-plus",
        to: "/othercost",
      },
      {
        access: false,
        text: "Register Items",
        icon: "fas fa-boxes",
        to: "/RegItem",
      },
      // {
      //   access: false,
      //   text: "New Inventory",
      //   icon: "fas fa-dolly",
      //   to: "/newInventory",
      // },
      {
        access: false,
        text: "Arrived",
        icon: "fas fa-clipboard-list",
        to: "/arrivedstock",
      },
    ],
  },
  // Sales Router
  {
    text: "Sales",
    hasChild: true,
    icon: "fas fa-hand-holding-usd",
    child: [
      {
        text: "Wholesale",
        access: false,
        icon: "fas fa-landmark",
        to: "/wholesale",
      },
      { text: "Retail", access: false, icon: "fas fa-coins", to: "/retail" },
      {
        text: "Clients",
        access: false,
        icon: "fas fa-users",
        to: "/clients",
      },
    ],
  },
  // Reports Router
  {
    text: "Reports",
    hasChild: true,
    icon: "fas fa-chart-pie",
    child: [
      {
        text: "Balance Sheet",
        access: false,
        icon: "fas fa-file-medical-alt",
        to: "/balancesheet",
      },
      {
        text: "Trail Balance",
        access: false,
        icon: "fas fa-balance-scale",
        to: "/trailbalance",
      },
      {
        text: "Cash Flow",
        access: false,
        icon: "fas fa-funnel-dollar",
        to: "/cashflow",
      },
      {
        text: "Sale Report",
        access: false,
        icon: "fas fa-receipt",
        to: "/sales",
      },
      {
        text: "Income",
        access: false,
        icon: "fas fa-file-invoice-dollar",
        to: "/income",
      },
      {
        text: "Debtors",
        access: false,
        icon: "fas fa-comment-dollar",
        to: "/debtors",
      },
    ],
  },
];
const commanLinks = [
  {
    hasChild: true,
    icon: "fas fa-laptop-house",
    text: "My Company",
    child: [
      {
        access: false,
        text: "Properties",
        icon: "fas fa-file-signature",
        to: "/properties",
      },
      {
        access: false,
        text: "Cash Dep",
        icon: "fas fa-hand-holding-usd",
        to: "/cashDep",
      },
      {
        access: false,
        text: "Cash Draw",
        icon: "fas fa-hand-holding",
        to: "/withdrowcash",
      },
      {
        access: false,
        text: "Cash Transfer",
        icon: "fas fa-exchange-alt",
        to: "/cashtransfer",
      },
      {
        access: false,
        text: "Delete",
        icon: "fas fa-trash-alt",
        to: "/deletetran",
      },
      {
        access: false,
        text: "All Summary",
        icon: "fas fa-file-medical-alt",
        to: "/AllSummary",
      },
      {
        access: false,
        text: "All Cash Balance",
        icon: "fas fa-chart-line",
        to: "/AllCash",
      },

      {
        access: false,
        text: "New Expense",
        icon: "fas fa-wallet",
        to: "/ExpenseEntry",
      },
      {
        access: false,
        text: "Fixed Expense",
        icon: "fas fa-handshake",
        to: "/FixedExpense",
      },
      {
        access: false,
        text: "Show Expenses",
        icon: "fas fa-receipt",
        to: "/expenses",
      },
    ],
  },
  {
    hasChild: true,
    icon: "fas fa-users-cog",
    text: "Users",
    child: [
      {
        access: false,
        text: "User Role",
        icon: "fas fa-tasks",
        to: "/groups",
      },
      {
        access: false,
        text: "User List",
        icon: "fas fa-user-check",
        to: "/AddUser",
      },
      // {
      //   access: false,
      //   text: "User Report",
      //   icon: "mdi-account-search",
      //   to: "/expenses"
      // }
    ],
  },
];
export const state = {
  AllLinks: [
    { text: "Home", access: false, icon: "fas fa-home", to: "/home" },
    ...BranchLink,
    ...HQLinks,
    ...commanLinks,

    { text: "New Bussines", icon: "mdi-account-tie", to: "/NewAccount" },
  ],
};
export const mutations = {};
export const actions = {};
export const getters = {
  LinksGetter(state) {
    return state.AllLinks;
  },
  GroupGetters: state => {
    return state.AllLinks.filter(link => {
      return link.text != "Users";
    });
  },
};
